import { css } from "@emotion/react";

export const VipDetailsItemMStyle = {
  wrapper: css`
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  textBox: css`
    position: absolute;

    top: 10%;
    left: 10px;
    font-weight: 700;
    text-shadow:
      -1px -1px 0 #000,
      1px -1px 0 #000,
      -1px 1px 0 #000,
      1px 1px 0 #000;
    color: #fff;

    font-family: "Roboto", "Helvetica Neue", sans-serif;

    h1 {
      font-size: 50px;
      letter-spacing: normal;
    }
    h4 {
      font-size: 14px;
      overflow: hidden;
      max-width: 150px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 15px;
      word-break: break-all;
      font-family: "Roboto", "Helvetica Neue", sans-serif;
      letter-spacing: normal;
    }
  `,

  info: css`
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    margin-bottom: 70px;
    padding-top: 183px;
    overflow: hidden;
    span {
      &:nth-of-type(2) {
        padding: 0 53px;
      }
      font-size: 10px;
      line-height: 15px;
      word-break: break-all;
      font-weight: bold;
      text-align: center;
      color: #f00;
    }
  `,
};
